var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ETaskMemberType } from "../../types/task.types";
export var ETaskCustomFilter;
(function (ETaskCustomFilter) {
    ETaskCustomFilter["Archived"] = "ARCHIVED";
    ETaskCustomFilter["NotArchived"] = "NOT_ARCHIVED";
    ETaskCustomFilter["All"] = "ALL";
})(ETaskCustomFilter || (ETaskCustomFilter = {}));
export var getOpenTasksFilter = function () {
    return {
        filter: { finishedAt: { is: null } },
        rolesFilter: [ETaskMemberType.Executor],
    };
};
// The comments endpoint pages by page number, not by offset. Rounding down
// means a page is re-read rather than skipped when the loaded count is not a
// multiple of the page size - after posting or deleting a comment, for
// instance - and `mergeComments` drops the overlap.
export var getNextCommentsPage = function (loadedCount, limit) {
    return Math.floor(loadedCount / limit) + 1;
};
export var mergeComments = function (loaded, page) {
    var loadedIds = new Set(loaded.map(function (comment) { return comment.id; }));
    return __spreadArray(__spreadArray([], loaded, true), page.filter(function (comment) { return !loadedIds.has(comment.id); }), true);
};
